import React, { PropTypes } from 'react';
import HappeningListItem from './HappeningListItem';
import langMap from '../../langMap';

const Happenings = (props) => {
  const { lang, happenings, edition, toggleHappenings } = props;
  const style = {
    backgroundColor: edition.background,
  };
  return (
    <div style={style} className={`fold fold--happenings ${props.front ? '' : 'fold--happenings--small'}`}>
      <button
        onClick={toggleHappenings} className="btn-toggle fold--happenings__toggle btn--text"
      />
      <section className="fold__col fold__col--happenings">
        <div className="fold__col--happenings__inner">
          <header className="fold__col__header">
            {
              lang === 'ar' ?
                <h2 className="fold__col__title">
                  <span className="fold__col__title__initial">
                    {langMap.happenings.arabicInitial}
                  </span>
                  <span className="fold__col__title__rest">{langMap.happenings.arabicRest}</span>
                </h2> :
                <h2 className="fold__col__title">
                  <span className="fold__col__title__initial">{langMap.happenings.initial}</span>
                  <span className="fold__col__title__rest">{langMap.happenings.rest}</span>
                </h2>
            }
          </header>
          <div className="fold__col__body fold__col__body--happenings">
            <ul className="c-happenings">
              {happenings.map(item =>
                <HappeningListItem
                  lang={lang}
                  {...item} key={item.id}
                  color={edition.background}
                  edition={edition.id}
                />,
              )}
            </ul>
          </div>
        </div>
      </section>
    </div>
  );
};

Happenings.propTypes = {
  happenings: PropTypes.arrayOf(PropTypes.object).isRequired,
  edition: PropTypes.shape({
    background: PropTypes.string,
    backgroundTextColor: PropTypes.string,
    year: PropTypes.string,
  }).isRequired,
  front: PropTypes.bool.isRequired,
  toggleHappenings: PropTypes.func.isRequired,
  lang: PropTypes.string.isRequired,
};

export default Happenings;



// WEBPACK FOOTER //
// ./js/components/happenings/Happenings.js